import React from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import { Divider } from "@material-ui/core";
import ListItem from '@material-ui/core/ListItem';
import AddBoxIcon from "@material-ui/icons/AddBox";
import InfoIcon from '@material-ui/icons/Info';
import SchoolIcon from '@material-ui/icons/School';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SettingsIcon from '@material-ui/icons/Settings';
import HomeIcon from "@material-ui/icons/Home";
import StyleIcon from "@material-ui/icons/Style";
import MenuIcon from "@material-ui/icons/Menu";
import ArchiveIcon from '@material-ui/icons/Archive';
import GroupIcon from '@material-ui/icons/Group';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import QuizIcon from '@material-ui/icons/HelpOutline';
import "../styles/navStyles.css";

const useStyles = makeStyles({
    fullList: {
      width: 'auto',
    },
});

const NavDrawer = props => {
    const classes = useStyles();
    const [state, setState] = React.useState({
        top: false,
        left: false,
        cme: {
            cmeTitle: '',
            cmeProgram: '',
            cmeShow: 0,
            cmeBody: ''
        }
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    }

    let cmeText = [];
        
    if (props.cmeYears) { 
        let _arr = props.cmeYears.reverse(); 
        for (let i of _arr) {
            let tcme = '20' + i.programID.replace('SASP', '') + ' (' + i.programID + ')';
            let _tobj = i;
            _tobj.title = tcme;
            _tobj.year = '20' + i.programID.replace('SASP', '');
            _tobj.year = Number(_tobj.year);

            cmeText.push(_tobj)
        }
    }

    const loc = {
        pathname: '/error',
        prevLoc: {
            pathname: '/menu',
            detail: 'testing',
            user: props.user_details.displayname
        }
    };

    const list = (anchor) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === 'top' || anchor === 'bottom',
            })}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List className="panel-list"
                role="presentation"
                onClick={toggleDrawer(anchor, false)}
                onKeyDown={toggleDrawer(anchor, false)}
            >
                <ListItem button key="Home">
                    <Link
                        to={{
                            pathname: "/home"
                        }}
                    >
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Home" />    
                    </Link>
                </ListItem>

                {typeof props.user_details.program !== 'undefined' && props.user_details.program.isprogram
                    ? (
                        <ListItem button key="Program">
                            <Link
                                to={{
                                    pathname: "/program"
                                }}
                            >
                                <ListItemIcon>
                                    <GroupIcon />
                                </ListItemIcon>
                                <ListItemText primary="Program" />
                            </Link>
                        </ListItem>

                    ) : null
                }

                <ListItem button key="Profile">
                    <Link
                        to={{
                            pathname: "/profile"
                        }}
                    >
                        <ListItemIcon>
                            <AccountCircleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Profile" />
                    </Link>
                </ListItem>

                <ListItem button key="Rankings">
                    <Link
                        to={{
                            pathname: "/leaderboard"
                        }}
                    >
                        <ListItemIcon>
                            <AddBoxIcon />
                        </ListItemIcon>
                        <ListItemText primary="Rankings" />
                    </Link>
                </ListItem>

                <ListItem button key="Create Deck">
                    <Link
                        to={{
                            pathname: "/createDeckScreen"
                        }}
                    >
                        <ListItemIcon>
                            <AddBoxIcon />
                        </ListItemIcon>
                        <ListItemText primary="Create Deck" />
                    </Link>
                </ListItem>

                <ListItem button key="My Quiz Results">
                    <Link
                        to={{
                            pathname: "/quizListAllScreen"
                        }}
                    >
                        <ListItemIcon>
                            <QuizIcon />
                        </ListItemIcon>
                        <ListItemText primary="My Quiz Results" />
                    </Link>
                </ListItem>
                
                <ListItem button key="My Decks">
                    <Link
                        to={{
                            pathname: "/myDecks"
                        }}
                    >
                        <ListItemIcon>
                            <StyleIcon />
                        </ListItemIcon>
                        <ListItemText primary="My Decks" />
                    </Link>
                </ListItem>

                <ListItem button key="My Flashcards">
                    <Link
                        to={{
                            pathname: "/myFlashCards"
                        }}
                    >
                        <ListItemIcon>
                            <StyleIcon />
                        </ListItemIcon>
                        <ListItemText primary="My Flashcards" />
                    </Link>
                </ListItem>

                <ListItem button key="My Notes">
                    <Link
                        to={{
                            pathname: "/myNotes"
                        }}
                    >
                        <ListItemIcon>
                            <LocalLibraryIcon />
                        </ListItemIcon>
                        <ListItemText primary="My Notes" />
                    </Link>
                </ListItem>

                <ListItem button key="Public Decks">
                    <Link
                        to={{
                            pathname: "/publicDecks"
                        }}
                    >
                        <ListItemIcon>
                            <ArchiveIcon />
                        </ListItemIcon>
                        <ListItemText primary="Public Decks" />
                    </Link>
                </ListItem>
            </List>
            <Divider />

            {/* {props.cmeYears
                ? (
                    <>
                        <List className="panel-list">
                            {cmeText.map((cme) => (
                                <ListItem button key={'CME-KEY-' + cme.programID}>
                                    {

                                    }
                                    <Link to={{
                                        pathname:"/cmeredirect",
                                        cme: cme
                                    }} >
                                        <ListItemIcon>
                                            <SchoolIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={'CME Info (' + cme.programID + ')'} />
                                    </Link>
                                </ListItem>  
                            ))}
                        </List>
                        <Divider />
                    </>
                ) : null
            } */}

            <List className="panel-list">
                <ListItem button key="Settings">
                    <Link
                        to={{
                            pathname: "/settings"
                        }}
                    >
                        <ListItemIcon>
                            <SettingsIcon />
                        </ListItemIcon>
                        <ListItemText primary="App Details" />
                    </Link>
                </ListItem>

                {props.user_details.mcid === '00863273'
                    ? (
                        <ListItem button key="Error">
                            <Link
                                to={loc}
                            >
                                <ListItemIcon>
                                    <InfoIcon />
                                </ListItemIcon>
                                <ListItemText primary="Error" />    
                            </Link>
                        </ListItem>
                    ) : null
                }
            </List>
            <Divider />

            {props.user_details.isProgram && 1 === 0
                ? (
                    <>
                        <List className="panel-list">
                            <ListItem button key="Settings">
                                <Link
                                    to={{
                                        pathname: "/program"
                                    }}
                                >
                                    <ListItemIcon>
                                        <SettingsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Residency Program" />
                                </Link>
                            </ListItem>
                        </List>
                        <Divider />
                    </>
                ) : null

                
            }
        </div>
    );

    return (
        <div>
            {['right'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <MenuIcon className="headerIcons"  onClick={toggleDrawer(anchor, true)} />
                    {/* <div onClick={toggleDrawer(anchor, true)}>
                        <MenuIcon className="headerIcons" />
                    </div> */}
                    <SwipeableDrawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                    >
                        {list(anchor)}
                    </SwipeableDrawer>
                </React.Fragment>
            ))}
        </div>
    )
}

const mapStateToProps = state => {
    const { auth, user_details } = state.auth;
    return { auth, user_details };
};

const MenuDrawer = connect(mapStateToProps)(NavDrawer);

export { MenuDrawer }